export default function SetContractEffectiveDate($http) {
  'ngInject';

  return function (responseId, effectiveDate) {
    console.warn(
      'The setContractEffectiveDate service has been deprecated and will be removed from a future release.'
    );

    //this should be  post
    return $http.get(
      '/aptitude/buyer/BuyerContractingServiceController/setEffectiveDate',
      {
        params: {
          responseId: responseId,
          effectiveDate: effectiveDate
        },

        intercept: true
      }
    );
  };
}
